export default __webpack_public_path__ + "static/media/logo.286fa841.png";